import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import PropertyAppResource from "./PropertyAppResource";
import EmailAppResource from "./EmailAppResource";
import PhoneAppResource from "./PhoneAppResource";
import WorkspaceAppResource from "./WorkspaceAppResource";
import LuPropertyContactTypeAppResource from "./LuPropertyContactTypeAppResource";

class PropertyContactAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'property-contact';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'property/contacts';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'created_at',
            'updated_at',
            'deleted_at',
            'search',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'propertyUuid',
            'workspaceUuid',
            'firstName',
            'lastName',
            'company',
            'website',
            'emails',
            'phones',
            'phonesMeta',
            'propertyContactTypes',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            property: PropertyAppResource,
            workspace: WorkspaceAppResource,
            phones: PhoneAppResource,
            emails: EmailAppResource,
            propertyContactTypes: LuPropertyContactTypeAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            property: 'propertyUuid',
            workspace: 'workspaceUuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            firstName: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
                presence: true,
            },
            lastName: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
                presence: true,
            },
            company: {
                type: 'string',
            },
            website: {
                type: 'string',
            },
            phonesMeta: {
                type: 'array'
            },
        };
    }

    setDirtyAttribute(attName, originalValue) {
        if (attName === 'phones'){
            super.setDirtyAttribute('phonesMeta');
        }
        return super.setDirtyAttribute(attName, originalValue);
    }
}

export default PropertyContactAppResource;
